<app-navbar></app-navbar>

<div class="editar-producto-container" *ngIf="!cargando; else cargandoTpl">
  <h2>Editar producto en {{ alojamientoName }}</h2>

  <form [formGroup]="productoForm" (ngSubmit)="guardarCambios()">
    <div>
      <label>Nombre</label>
      <input type="text" formControlName="nombre" />
    </div>

    <div>
      <label>Descripción</label>
      <textarea formControlName="descripcion"></textarea>
    </div>

    <div>
      <label>Precio</label>
      <input type="number" formControlName="precio" />
    </div>

    <div>
      <label>Impuesto</label>
      <input type="number" formControlName="impuesto" />
    </div>

    <div>
      <label>Stock</label>
      <input type="number" formControlName="stock" />
    </div>

    <button type="submit">Guardar cambios</button>
  </form>
</div>

<ng-template #cargandoTpl>
  <p>Cargando producto...</p>
</ng-template>

<app-footer></app-footer>
